export default function SaveRecommendationConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveRecommendationDialog = _handleSaveRecommendationDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    loaderService.showViewLoader = false;
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.saveRecommendationConfirmDialog);
  }

  function _handleSaveRecommendationDialog() {
    return amSharedModelService.saveRecommendation(vm.recommendation)
      .then(() => {
        alerts.success('The Recommendation has been saved successfully.');
        if (vm.recommendation.recommendationId > 0) {
          $rootScope.$broadcast('refreshAMRecommendation', { recommendationId: vm.recommendation.recommendationId });
        } else {
          $rootScope.$broadcast('refreshAMRecommendations', { recommendationCategoryId: vm.recommendation.recommendationCategoryId });
        }
        ssDialogService.hide(ssDialogService.dialogs.auditTrail.saveRecommendationConfirmDialog);
      })
      .catch(() => {
        alerts.error('Error occurred while saving the Recommendation.');
      });
  }
}

SaveRecommendationConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amSharedModelService',
  'loaderService',
  'ssDialogService'
];
